<div class="bg-night border border-white/10 rounded-xl p-6 min-w-[400px]">
  <div class="flex items-start gap-4 mb-6">
    @if (data.icon) {
      <div
        class="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center"
        [ngClass]="{
          'bg-error/20': data.type === 'danger',
          'bg-neon/20': data.type === 'warning',
          'bg-gray/20': data.type === 'info',
          'bg-white/10': !data.type,
        }">
        <svg
          class="w-6 h-6"
          [ngClass]="{
            'text-error': data.type === 'danger',
            'text-neon': data.type === 'warning',
            'text-gray': data.type === 'info',
            'text-white/70': !data.type,
          }"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24">
          @if (data.type === 'danger') {
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
          } @else if (data.type === 'warning') {
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          } @else if (data.type === 'info') {
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          } @else {
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          }
        </svg>
      </div>
    }

    <div class="flex-1">
      <h2 class="text-xl font-semibold text-white mb-2">
        {{ data.title }}
      </h2>
      <p class="text-white/70 leading-relaxed">
        {{ data.message }}
      </p>
    </div>
  </div>

  <div class="flex justify-end gap-3">
    <button
      data-testid="btn-confirm-cancel"
      type="button"
      (click)="onCancel()"
      class="px-4 py-2 bg-transparent border border-white/20 text-white rounded-full hover:bg-white/10 transition-colors">
      {{ data.cancelText || ('admin.common.cancel' | translate) }}
    </button>

    <button
      data-testid="btn-confirm"
      type="button"
      (click)="onConfirm()"
      [class]="
        'px-4 py-2 rounded-full font-medium transition-colors ' +
        (data.type === 'danger' ? 'bg-error hover:bg-error/80 text-white' : 'bg-neon hover:bg-neon/90 text-night')
      ">
      {{ data.confirmText || ('admin.common.confirm' | translate) }}
    </button>
  </div>
</div>
